var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { InlineImage } from '../InlineImage';
import { LucidLinkLogoTestIdFactory } from './interactions';
import imageLucidlinkLogoHorizontalBlack from '../../assets/logos/lucidlink-logo-horizontal-black.asset.svg';
import imageLucidlinkLogoHorizontalColorfulBlack from '../../assets/logos/lucidlink-logo-horizontal-colorful-black.asset.svg';
import imageLucidlinkLogoHorizontalColorfulWhite from '../../assets/logos/lucidlink-logo-horizontal-colorful-white.asset.svg';
import imageLucidlinkLogoHorizontalWhite from '../../assets/logos/lucidlink-logo-horizontal-white.asset.svg';
import imageLucidlinkLogoIconBlack from '../../assets/logos/lucidlink-logo-icon-black.asset.svg';
import imageLucidlinkLogoIconColorful from '../../assets/logos/lucidlink-logo-icon-colorful.asset.svg';
import imageLucidlinkLogoIconWhite from '../../assets/logos/lucidlink-logo-icon-white.asset.svg';
import imageLucidlinkLogoVerticalBlack from '../../assets/logos/lucidlink-logo-vertical-black.asset.svg';
import imageLucidlinkLogoVerticalColorfulBlack from '../../assets/logos/lucidlink-logo-vertical-colorful-black.asset.svg';
import imageLucidlinkLogoVerticalColorfulWhite from '../../assets/logos/lucidlink-logo-vertical-colorful-white.asset.svg';
import imageLucidlinkLogoVerticalWhite from '../../assets/logos/lucidlink-logo-vertical-white.asset.svg';
const KIND_TO_SRC = {
    'horizontal-black': imageLucidlinkLogoHorizontalBlack,
    'horizontal-colorful-black': imageLucidlinkLogoHorizontalColorfulBlack,
    'horizontal-colorful-white': imageLucidlinkLogoHorizontalColorfulWhite,
    'horizontal-white': imageLucidlinkLogoHorizontalWhite,
    'icon-black': imageLucidlinkLogoIconBlack,
    'icon-colorful': imageLucidlinkLogoIconColorful,
    'icon-white': imageLucidlinkLogoIconWhite,
    'vertical-black': imageLucidlinkLogoVerticalBlack,
    'vertical-colorful-black': imageLucidlinkLogoVerticalColorfulBlack,
    'vertical-colorful-white': imageLucidlinkLogoVerticalColorfulWhite,
    'vertical-white': imageLucidlinkLogoVerticalWhite,
};
export const LucidLinkLogo = ({ alt, 'data-testid': testid, height, kind, width, }) => {
    const src = KIND_TO_SRC[kind];
    return (_jsx(InlineImage, { alt: alt, "data-testid": LucidLinkLogoTestIdFactory.getLucidLinkLogoTestId(testid), height: height, src: src, width: width }));
};
_react_refresh_temp_1 = LucidLinkLogo;
$RefreshReg$(_react_refresh_temp_1, "LucidLinkLogo");
